import { render, staticRenderFns } from "./revenueByBrand.vue?vue&type=template&id=8b1d021e&scoped=true"
import script from "./revenueByBrand.vue?vue&type=script&lang=js"
export * from "./revenueByBrand.vue?vue&type=script&lang=js"
import style0 from "./revenueByBrand.vue?vue&type=style&index=0&id=8b1d021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1d021e",
  null
  
)

export default component.exports